/* file not open for review yet - working on UI only */

import { type AxiosRequestConfig } from 'axios';

import { fetchApi, getSaviApiUrlLists } from '../../services';
import {
  type DownloadDataErrorResponse,
  type DownloadDataRequest,
  type DownloadDataSuccessResponse,
} from '../types';

const { DATA_DOWNLOAD_URL } = getSaviApiUrlLists(false);

function isDownloadResponse(
  data: unknown
): data is DownloadDataSuccessResponse | DownloadDataErrorResponse | Blob {
  if (data instanceof Blob) {
    return true;
  }

  return typeof data === 'object' && data !== null && 'status' in data;
}

const callDownloadApi = async (
  request: DownloadDataRequest,
  url?: string
): Promise<DownloadDataSuccessResponse | DownloadDataErrorResponse | Blob> => {
  const downloadUrl = url ?? DATA_DOWNLOAD_URL;

  const options: AxiosRequestConfig = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: request,
    responseType: 'blob',
  };

  const response = await fetchApi<
    DownloadDataSuccessResponse | DownloadDataErrorResponse | Blob
  >(downloadUrl, options, isDownloadResponse);

  return response;
};

export default callDownloadApi;
